import { render, staticRenderFns } from "./ChecklistConfigurations.vue?vue&type=template&id=d13fa222"
import script from "./ChecklistConfigurations.vue?vue&type=script&lang=js"
export * from "./ChecklistConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports